import React, { useState, useEffect } from "react";

function ParticipatedTimer({ status, data, getProfile }) {
  const [timeRemaining, setTimeRemaining] = useState("");
  // console.log(status, data, "status, data, getProfile");

  const calculateTimeRemaining = (targetTime) => {
    const now = new Date();
    const diff = new Date(targetTime) - now;

    if (diff <= 0) {
      getProfile();
      return "Time Ended";
    }

    const days = Math.floor(diff / (1000 * 60 * 60 * 24));
    const hours = Math.floor((diff / (1000 * 60 * 60)) % 24);
    const minutes = Math.floor((diff / (1000 * 60)) % 60);
    const seconds = Math.floor((diff / 1000) % 60);

    return `${days > 0 ? `${days}d ` : ""}${hours}h ${minutes}m ${seconds}s`;
  };

  const getTargetTime = () => {
    const currentTime = new Date();
    const endTime = new Date(data?.endTime);
    const reviewTimePeriod = new Date(data?.reviewTimePeriod);
    const coolDownPeriod = new Date(data?.coolDownPeriod);
    const votingEndPeriod = new Date(data?.votingEndPeriod);

    // if (
    //   data?.status === "inProgress" &&
    //   currentTime < endTime &&
    //   data?.status !== "ended"
    // ) {
    //   return endTime;
    // } else if (
    //   currentTime > endTime &&
    //   currentTime < reviewTimePeriod &&
    //   data?.status !== "ended"
    // ) {
    //   return reviewTimePeriod;
    // } else {
    //   return null;
    // }
    // else if (
    //     currentTime > reviewTimePeriod &&
    //     currentTime < coolDownPeriod &&
    //     status === 'inDispute'
    // ) {
    //     return votingEndPeriod; // Timer for 'inDispute' status
    // }
    //  else if (currentTime > reviewTimePeriod && currentTime < coolDownPeriod) {
    //     return coolDownPeriod;
    // }
    // return null; // No active timer
    if (
      currentTime < endTime && data?.status === "inProgress"
    ) {
      return endTime;
    } else if (
      currentTime < reviewTimePeriod
    ) {
      return reviewTimePeriod;
    }
    else if (
      currentTime < coolDownPeriod
    ) {
      return coolDownPeriod; // Timer for 'inDispute' status
    } else if (currentTime < votingEndPeriod) {
      return votingEndPeriod;
    }
    return null; // No active timer
  };

  useEffect(() => {
    const targetTime = getTargetTime();
    if (!targetTime) {
      setTimeRemaining("Time Ended");
      return;
    }

    const updateTimer = () => {
      const remaining = calculateTimeRemaining(targetTime);
      setTimeRemaining(remaining);
    };

    updateTimer();
    const timerInterval = setInterval(updateTimer, 1000);

    return () => clearInterval(timerInterval); // Cleanup on component unmount
  }, [data, status]);

  return <p className="tablepara">{timeRemaining}</p>;
}

export default ParticipatedTimer;
